import React, { useState, useEffect, useRef } from 'react';
import { Button, Table, Form, Row, Col, Card, Modal } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import axios from '../../axios/axiosconf';
import html2pdf from "html2pdf-fix-jspdf";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import Loading from "../general/Loading";
import Unauthorized from "../general/Unauthorized";
import RegistroRipsSinFev from "../rips/RegistroRipsSinFev";
import RegistroRipsFev from "../rips/RegistroRipsFev";
import RegistroRipsConvenio from "../rips/RegistroRipsConvenio";
import ModalExamenes from "./ModalExamenes";
import ModalFormulas from "./ModalFormulas";
import ModalIncapacidades from "./ModalIncapacidades";
import ModalRecomendaciones from "./ModalRecomendaciones";
import ModalRemisiones from "./ModalRemisiones";
import ModalContraremisiones from "./ModalContraremisiones";
import ModalConsentimientos from "./ModalConsentimientos";
import ModalOdontograma from "./ModalOdontograma";
import ModalArchivosClinicos from "./ModalArchivosClinicos";
import DocumentoPacienteModal from "./DocumentoPacienteModal";

// Importar imágenes
import imgFrente from '../../../resources/img/toxina/1.png';
import imgLateral from '../../../resources/img/toxina/2.png';

function ToxinaBotulinica() {
    const history = useHistory();
    const queryParams = useLocation().search;
    const paciente_id = new URLSearchParams(queryParams).get('id');

    // Estados de autenticación
    const [hasPermission, setHasPermission] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);

    // Menú lateral atención paciente
    const [esFacturador, setEsFacturador] = useState(false);
    const [tienePermisoDocumentos, setTienePermisoDocumentos] = useState(false);
    const [tienePermisoRips, setTienePermisoRips] = useState(false);
    const [tienePermisoToxina, setTienePermisoToxina] = useState(false);
    const [tienePermisoOdontograma, setTienePermisoOdontograma] = useState(false);
    const [tienePermisoEvolucion, setTienePermisoEvolucion] = useState(false);
    const [tienePermisoHistoriaClinica, setTienePermisoHistoriaClinica] = useState(false);
    const [showRipsFev, setShowRipsFev] = useState(false);
    const [showRipsSinFev, setShowRipsSinFev] = useState(false);
    const [showRipsConvenio, setShowRipsConvenio] = useState(false);
    const [showExamenes, setShowExamenes] = useState(false);
    const [showFormulas, setShowFormulas] = useState(false);
    const [showIncapacidades, setShowIncapacidades] = useState(false);
    const [showRecomendaciones, setShowRecomendaciones] = useState(false);
    const [showRemisiones, setShowRemisiones] = useState(false);
    const [showContraremisiones, setShowContraremisiones] = useState(false);
    const [showConsentimientos, setShowConsentimientos] = useState(false);
    const [showOdontograma, setShowOdontograma] = useState(false);
    const [showArchivosClinicos, setShowArchivosClinicos] = useState(false);
    const [cargarHistorialExamenes, setCargarHistorialExamenes] = useState(false);
    const [cargarHistorialFormulas, setCargarHistorialFormulas] = useState(false);
    const [cargarHistorialIncapacidades, setCargarHistorialIncapacidades] = useState(false);
    const [cargarHistorialRecomendaciones, setCargarHistorialRecomendaciones] = useState(false);
    const [cargarHistorialRemisiones, setCargarHistorialRemisiones] = useState(false);
    const [cargarHistorialContraremisiones, setCargarHistorialContraremisiones] = useState(false);
    const [cargarHistorialConsentimientos, setCargarHistorialConsentimientos] = useState(false);
    const [cargarHistorialRipsConvenio, setCargarHistorialRipsConvenio] = useState(false);

    // Estados principales
    const [view, setView] = useState('list'); // 'list', 'create', 'show'
    const [loading, setLoading] = useState(false);
    const [registros, setRegistros] = useState([]);

    // Datos del paciente
    const [paciente, setPaciente] = useState(null);

    // Estados de puntos separados
    const [puntosFrente, setPuntosFrente] = useState({ puntos: [] });
    const [puntosLateral, setPuntosLateral] = useState({ puntos: [] });

    // Pestaña activa
    const [activeTab, setActiveTab] = useState('frente');

    const [herramienta, setHerramienta] = useState('toxina'); // 'toxina', 'borrador'
    const [valorDefecto, setValorDefecto] = useState('5');
    const [fechaHora, setFechaHora] = useState('');
    const [observaciones, setObservaciones] = useState('');
    const [profesionalName, setProfesionalName] = useState('');

    const [encabezadoPersonalizado, setEncabezadoPersonalizado] = useState(null);

    // Refs para obtener coordenadas
    const imgFrenteRef = useRef(null);
    const imgLateralRef = useRef(null);

    // Validación de permisos y carga inicial
    useEffect(() => {
        if (!localStorage.getItem('userdata')) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        const userdata = JSON.parse(localStorage.getItem('userdata'));

        // Validación de permisos híbrida
        let tienePermiso = false;
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => permission.slug === 'atenderPacientes');
        } else if (userdata.up && userdata.up.includes('atenderPacientes')) {
            tienePermiso = true;
        }

        if (!tienePermiso) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        setHasPermission(true);

        const verificarPermisoSlug = (slug) => {
            if (userdata.permissions && Array.isArray(userdata.permissions)) {
                return userdata.permissions.some(p => p.slug === slug);
            }
            if (userdata.up && Array.isArray(userdata.up)) {
                return userdata.up.includes(slug);
            }
            return false;
        };
        setTienePermisoDocumentos(verificarPermisoSlug('documentosPaciente'));
        setTienePermisoRips(verificarPermisoSlug('ripsPaciente'));
        setTienePermisoToxina(verificarPermisoSlug('toxinaPaciente'));
        setTienePermisoOdontograma(verificarPermisoSlug('odontogramaPaciente'));
        setTienePermisoEvolucion(verificarPermisoSlug('evolucionPaciente'));
        setTienePermisoHistoriaClinica(verificarPermisoSlug('historiaClinicaPaciente'));
        setEsFacturador(parseInt(userdata?.facturador, 10) === 0);

        // Cargar datos
        cargarDatosIniciales();
    }, [paciente_id]);

    const cargarDatosIniciales = async () => {
        try {
            const userdata = JSON.parse(localStorage.getItem('userdata'));

            // Cargar perfil profesional
            const responsePerfil = await axios.get('/perfil');
            if (responsePerfil.status === 200) {
                setProfesionalName(responsePerfil.data.name + ' ' + responsePerfil.data.lastname);
            }

            // Cargar encabezado personalizado
            const responseEncabezado = await axios.get('/encabezado-personalizado?uid=' + userdata.user_id);
            if (responseEncabezado.status === 200 && responseEncabezado.data && responseEncabezado.data.estado === 1) {
                setEncabezadoPersonalizado(responseEncabezado.data);
            }

            // Cargar datos del paciente
            const responsePaciente = await axios.get('/paciente', {
                params: { id: paciente_id }
            });
            if (responsePaciente.status === 200 && responsePaciente.data[0]) {
                const datosPaciente = responsePaciente.data[0];
                setPaciente({
                    ...datosPaciente,
                    id: datosPaciente.id,
                    primerNombre: datosPaciente.primer_nombre || '',
                    segundoNombre: datosPaciente.segundo_nombre || '',
                    primerApellido: datosPaciente.primer_apellido || '',
                    segundoApellido: datosPaciente.segundo_apellido || '',
                    numeroDocumento: datosPaciente.numero_documento || '',
                    tipoDocumento: datosPaciente.tipo_documento || 'CC',
                });
            }

            // Cargar historial
            cargarHistorial();
            setLoggedIn(true);

        } catch (error) {
            console.error('Error cargando datos iniciales:', error);
            setLoggedIn(true);
        }
    };

    const cargarHistorial = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`/toxinas-paciente?paciente_id=${paciente_id}`);
            setRegistros(response.data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleNuevo = () => {
        setPuntosFrente({ puntos: [] });
        setPuntosLateral({ puntos: [] });
        setObservaciones('');
        setActiveTab('frente');

        const now = new Date();
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
        setFechaHora(now.toISOString().slice(0, 16));

        setView('create');
    };

    const handleVer = (item) => {
        try {
            // Cargar datos Frente (datos)
            let dataFrente = typeof item.datos === 'string' ? JSON.parse(item.datos) : item.datos;

            // Adaptar estructura antigua si es necesario
            if (dataFrente.completo) {
                setPuntosFrente({ puntos: dataFrente.completo });
                setPuntosLateral({ puntos: [] });
            } else {
                setPuntosFrente(dataFrente || { puntos: [] });
            }

            // Cargar datos Lateral (datos2)
            if (item.datos2) {
                let dataLateral = typeof item.datos2 === 'string' ? JSON.parse(item.datos2) : item.datos2;
                setPuntosLateral(dataLateral || { puntos: [] });
            } else {
                setPuntosLateral({ puntos: [] });
            }

            setFechaHora(item.fecha_hora);
            setObservaciones(item.observaciones || '');
            setProfesionalName(item.profesional_nombre || 'Desconocido');
            setView('show');
            setActiveTab('frente');
        } catch (e) {
            console.error(e);
            alert("Error al cargar datos.");
        }
    };

    const guardar = async () => {
        if (puntosFrente.puntos.length === 0 && puntosLateral.puntos.length === 0) {
            alert("No has marcado ningún punto en ninguna vista.");
            return;
        }

        setLoading(true);
        try {
            const payload = {
                paciente_id: paciente_id,
                fecha_hora: fechaHora,
                datos: JSON.stringify(puntosFrente),
                datos2: JSON.stringify(puntosLateral),
                observaciones: observaciones
            };

            await axios.post('/toxina', payload);
            alert("Guardado correctamente.");
            cargarHistorial();
            setView('list');
        } catch (err) {
            console.error(err);
            alert("Error al guardar.");
        } finally {
            setLoading(false);
        }
    };

    // Manejo de Clics en Imagen
    const handleImageClick = (e, tipo) => {
        if (view === 'show') return;

        const rect = e.target.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const xPerc = (x / rect.width) * 100;
        const yPerc = (y / rect.height) * 100;

        if (herramienta === 'toxina') {
            let val = valorDefecto;
            if (!val) {
                val = prompt("Ingrese cantidad de unidades:", "5");
            }
            if (!val) return;

            const nuevoPunto = {
                id: Date.now(),
                x: xPerc,
                y: yPerc,
                valor: val
            };

            if (tipo === 'frente') {
                setPuntosFrente(prev => ({ ...prev, puntos: [...prev.puntos, nuevoPunto] }));
            } else {
                setPuntosLateral(prev => ({ ...prev, puntos: [...prev.puntos, nuevoPunto] }));
            }
        }
    };

    const handlePuntoClick = (e, index, tipo) => {
        e.stopPropagation();
        if (view === 'show') return;

        if (herramienta === 'borrador') {
            if (tipo === 'frente') {
                setPuntosFrente(prev => {
                    const newList = [...prev.puntos];
                    newList.splice(index, 1);
                    return { ...prev, puntos: newList };
                });
            } else {
                setPuntosLateral(prev => {
                    const newList = [...prev.puntos];
                    newList.splice(index, 1);
                    return { ...prev, puntos: newList };
                });
            }
        }
    };

    // Renderizar Puntos
    const renderPuntos = (tipo) => {
        const puntosList = tipo === 'frente' ? puntosFrente.puntos : puntosLateral.puntos;

        return (puntosList || []).map((p, i) => (
            <div
                key={p.id || i}
                onClick={(e) => handlePuntoClick(e, i, tipo)}
                style={{
                    position: 'absolute',
                    left: `${p.x}%`,
                    top: `${p.y}%`,
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 0, 0, 0.7)',
                    border: '2px solid white',
                    transform: 'translate(-50%, -50%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontSize: '10px',
                    fontWeight: 'bold',
                    cursor: view === 'create' && herramienta === 'borrador' ? 'not-allowed' : 'pointer',
                    zIndex: 10
                }}
                title={`Valor: ${p.valor}`}
            >
                {p.valor}
            </div>
        ));
    };

    // Calcular total de unidades
    const calcularTotal = (tipo) => {
        const puntosList = tipo === 'frente' ? (puntosFrente.puntos || []) : (puntosLateral.puntos || []);
        return puntosList.reduce((acc, curr) => acc + (parseFloat(curr.valor) || 0), 0);
    };

    const calcularTotalGlobal = () => {
        return calcularTotal('frente') + calcularTotal('lateral');
    };

    // PDF HORIZONTAL con layout: datos a la izquierda, imagen a la derecha
    const descargarPDF = () => {
        const generarEncabezado = () => {
            if (!encabezadoPersonalizado) return '';
            const limpiarHTML = (html) => html ? html.replace(/<p>/gi, '<div style="margin:0;line-height:1.1;">').replace(/<\/p>/gi, '</div>') : '';
            return `
                <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px;">
                    <tr>
                        <td style="width: 30%; font-size: 8px; vertical-align: top;">${limpiarHTML(encabezadoPersonalizado.izquierda)}</td>
                        <td style="width: 40%; text-align: center; font-size: 9px; vertical-align: top;">${limpiarHTML(encabezadoPersonalizado.centro)}</td>
                        <td style="width: 30%; text-align: right; font-size: 8px; vertical-align: top;">${limpiarHTML(encabezadoPersonalizado.derecha)}</td>
                    </tr>
                </table>
            `;
        };

        const generarBandaGris = (titulo) => `
            <div style="background-color: #f0f0f0; padding: 6px; margin: 8px 0; border-left: 4px solid #007bff;">
                <strong style="color: #333; font-size: 11px;">${titulo}</strong>
            </div>
        `;

        const formatearFecha = (fecha) => {
            if (!fecha) return '';
            const d = new Date(fecha);
            return d.toLocaleString('es-CO', { 
                year: 'numeric', 
                month: '2-digit', 
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            });
        };

        const opt = {
            margin: [8, 8, 8, 8],
            filename: `toxina-botulinica-${paciente?.numeroDocumento || paciente?.numero_documento || 'paciente'}-${new Date().getTime()}.pdf`,
            image: { type: 'jpeg', quality: 0.95 },
            html2canvas: { scale: 2, useCORS: true, logging: false },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'landscape' },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
        };

        const generarPaginaVista = (tipo, imagen, puntos, titulo) => `
            <div style="page-break-after: ${tipo === 'frente' ? 'always' : 'auto'};">
                ${generarEncabezado()}
                
                <h2 style="text-align: center; color: #007bff; margin: 8px 0; font-size: 14px; border-bottom: 2px solid #007bff; padding-bottom: 6px;">
                    APLICACIÓN TOXINA BOTULÍNICA
                </h2>

                <!-- Layout Horizontal: Datos a la izquierda, Imagen a la derecha -->
                <table style="width: 100%; border-collapse: collapse;">
                    <tr>
                        <!-- COLUMNA IZQUIERDA: DATOS (40%) -->
                        <td style="width: 40%; vertical-align: top; padding-right: 15px;">
                            
                            ${generarBandaGris('INFORMACIÓN DEL PACIENTE')}
                            <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px; font-size: 10px;">
                                <tr>
                                    <td style="padding: 4px;"><strong>Paciente:</strong></td>
                                    <td style="padding: 4px;">${paciente.primerNombre} ${paciente.primerApellido}</td>
                                </tr>
                                <tr>
                                    <td style="padding: 4px;"><strong>Documento:</strong></td>
                                    <td style="padding: 4px;">${paciente.numeroDocumento}</td>
                                </tr>
                                <tr>
                                    <td style="padding: 4px;"><strong>Fecha:</strong></td>
                                    <td style="padding: 4px;">${formatearFecha(fechaHora)}</td>
                                </tr>
                                <tr>
                                    <td style="padding: 4px;"><strong>Profesional:</strong></td>
                                    <td style="padding: 4px;">${profesionalName}</td>
                                </tr>
                            </table>

                            ${generarBandaGris('RESUMEN DE UNIDADES - ' + titulo.toUpperCase())}
                            <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px; border: 1px solid #ddd; font-size: 10px;">
                                <thead>
                                    <tr style="background-color: #007bff; color: white;">
                                        <th style="padding: 6px; text-align: left; border: 1px solid #ddd;">Vista</th>
                                        <th style="padding: 6px; text-align: center; border: 1px solid #ddd;">Unidades</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr style="background-color: #e3f2fd;">
                                        <td style="padding: 6px; border: 1px solid #ddd;"><strong>${titulo}</strong></td>
                                        <td style="padding: 6px; text-align: center; border: 1px solid #ddd; font-weight: bold; font-size: 12px; color: #007bff;">${calcularTotal(tipo)} U</td>
                                    </tr>
                                </tbody>
                            </table>

                            ${observaciones && tipo === 'lateral' ? `
                                ${generarBandaGris('OBSERVACIONES')}
                                <div style="border: 1px solid #ddd; padding: 8px; background-color: #f9f9f9; font-size: 9px; white-space: pre-wrap; max-height: 120px; overflow: hidden;">
                                    ${observaciones}
                                </div>
                            ` : ''}

                            ${tipo === 'lateral' ? `
                                <div style="margin-top: 15px; padding-top: 10px; border-top: 1px solid #ddd;">
                                    <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd; font-size: 10px;">
                                        <thead>
                                            <tr style="background-color: #28a745; color: white;">
                                                <th style="padding: 6px; text-align: left; border: 1px solid #ddd;">TOTAL GLOBAL</th>
                                                <th style="padding: 6px; text-align: center; border: 1px solid #ddd;">Unidades</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="background-color: #d4edda;">
                                                <td style="padding: 6px; border: 1px solid #ddd;"><strong>Ambas Vistas</strong></td>
                                                <td style="padding: 6px; text-align: center; border: 1px solid #ddd; font-weight: bold; font-size: 14px; color: #28a745;">${calcularTotalGlobal()} U</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            ` : ''}

                        </td>

                        <!-- COLUMNA DERECHA: IMAGEN (60%) -->
                        <td style="width: 60%; vertical-align: top; text-align: center;">
                            ${generarBandaGris(titulo.toUpperCase() + ' - PUNTOS DE APLICACIÓN')}
                            <div style="position: relative; display: inline-block; max-width: 100%;">
                                <img src="${imagen}" alt="${titulo}" style="max-width: 100%; height: auto; max-height: 420px;" />
                                <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;">
                                    ${puntos.map(p => `
                                        <div style="position: absolute; left: ${p.x}%; top: ${p.y}%; width: 22px; height: 22px; border-radius: 50%; background-color: rgba(255, 0, 0, 0.7); border: 2px solid white; transform: translate(-50%, -50%); display: flex; align-items: center; justify-content: center; color: white; font-size: 10px; font-weight: bold;">
                                            ${p.valor}
                                        </div>
                                    `).join('')}
                                </div>
                            </div>
                            <p style="margin-top: 8px; font-size: 10px; color: #666;">
                                <strong>Total ${titulo}:</strong> ${calcularTotal(tipo)} Unidades
                            </p>
                        </td>
                    </tr>
                </table>

                ${tipo === 'lateral' ? `
                    <div style="margin-top: 10px; text-align: center; font-size: 8px; color: #666; border-top: 1px solid #ddd; padding-top: 5px;">
                        <p>Documento generado el ${new Date().toLocaleString('es-CO')}</p>
                    </div>
                ` : ''}
            </div>
        `;

        const html = `
            <div style="font-family: Arial, sans-serif; font-size: 10px; color: #333;">
                ${generarPaginaVista('frente', imgFrente, puntosFrente.puntos || [], 'Vista Frontal')}
                ${generarPaginaVista('lateral', imgLateral, puntosLateral.puntos || [], 'Vista Lateral')}
            </div>
        `;

        html2pdf(html, opt);
    };

    const volverAtenderPaciente = () => {
        history.push(`/atender-paciente?id=${paciente_id}`);
    };

    const getInfoAnamnesisPDF = () => '';

    const obtenerPacienteParaRips = () => ({
        id: paciente?.id || paciente_id,
        primerNombre: paciente?.primerNombre || paciente?.primer_nombre || '',
        segundoNombre: paciente?.segundoNombre || paciente?.segundo_nombre || '',
        primerApellido: paciente?.primerApellido || paciente?.primer_apellido || '',
        segundoApellido: paciente?.segundoApellido || paciente?.segundo_apellido || '',
        numeroDocumento: paciente?.numeroDocumento || paciente?.numero_documento || '',
        tipoDocumento: paciente?.tipoDocumento || paciente?.tipo_documento || 'CC',
    });

    const abrirEvolucion = () => history.push(`/evolucion-paciente?id=${paciente_id}`);
    const abrirHistoriaClinicaJson = () => history.push(`/historia-clinica-json?id=${paciente_id}`);
    const abrirExamenes = () => { setShowExamenes(true); setCargarHistorialExamenes(true); };
    const cerrarExamenes = () => { setShowExamenes(false); setCargarHistorialExamenes(false); };
    const abrirFormulas = () => { setShowFormulas(true); setCargarHistorialFormulas(true); };
    const cerrarFormulas = () => { setShowFormulas(false); setCargarHistorialFormulas(false); };
    const abrirIncapacidades = () => { setShowIncapacidades(true); setCargarHistorialIncapacidades(true); };
    const cerrarIncapacidades = () => { setShowIncapacidades(false); setCargarHistorialIncapacidades(false); };
    const abrirRecomendaciones = () => { setShowRecomendaciones(true); setCargarHistorialRecomendaciones(true); };
    const cerrarRecomendaciones = () => { setShowRecomendaciones(false); setCargarHistorialRecomendaciones(false); };
    const abrirRemisiones = () => { setShowRemisiones(true); setCargarHistorialRemisiones(true); };
    const cerrarRemisiones = () => { setShowRemisiones(false); setCargarHistorialRemisiones(false); };
    const abrirContraremisiones = () => { setShowContraremisiones(true); setCargarHistorialContraremisiones(true); };
    const cerrarContraremisiones = () => { setShowContraremisiones(false); setCargarHistorialContraremisiones(false); };
    const abrirConsentimientos = () => { setShowConsentimientos(true); setCargarHistorialConsentimientos(true); };
    const cerrarConsentimientos = () => { setShowConsentimientos(false); setCargarHistorialConsentimientos(false); };
    const abrirOdontograma = () => { setShowOdontograma(true); };
    const cerrarOdontograma = () => { setShowOdontograma(false); };

    const abrirArchivosClinicos = () => {
        setShowArchivosClinicos(true);
    };
    const cerrarArchivosClinicos = () => {
        setShowArchivosClinicos(false);
    };
    const abrirToxina = () => {
        history.push(`/toxina-botulinica?id=${paciente_id}`);
    };
    const abrirRipsConvenio = () => { setShowRipsConvenio(true); setCargarHistorialRipsConvenio(true); };
    const cerrarRipsConvenio = () => { setShowRipsConvenio(false); setCargarHistorialRipsConvenio(false); };

    const nombrePacienteListado = `${paciente?.primerNombre || paciente?.primer_nombre || ''} ${paciente?.primerApellido || paciente?.primer_apellido || ''}`.trim();

    // Protección de rutas
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (!loggedIn) {
        return <Loading />;
    }

    return (
        <div className="wrapper">
            <Header />
            <Aside
                activelink="patients"
                atencionPaciente={true}
                abrirArchivosClinicos={abrirArchivosClinicos}
                abrirEvolucion={abrirEvolucion}
                abrirHistoriaClinicaJson={abrirHistoriaClinicaJson}
                abrirExamenes={abrirExamenes}
                abrirFormulas={abrirFormulas}
                abrirIncapacidades={abrirIncapacidades}
                abrirRecomendaciones={abrirRecomendaciones}
                abrirRemisiones={abrirRemisiones}
                abrirContraremisiones={abrirContraremisiones}
                abrirConsentimientos={abrirConsentimientos}
                abrirRipsFev={() => setShowRipsFev(true)}
                abrirRipsSinFev={() => setShowRipsSinFev(true)}
                abrirRipsConvenio={abrirRipsConvenio}
                abrirOdontograma={abrirOdontograma}
                abrirToxina={abrirToxina}
                esFacturador={esFacturador}
                tienePermisoDocumentos={tienePermisoDocumentos}
                tienePermisoRips={tienePermisoRips}
                tienePermisoOdontograma={tienePermisoOdontograma}
                tienePermisoToxina={tienePermisoToxina}
                tienePermisoEvolucion={tienePermisoEvolucion}
                tienePermisoHistoriaClinica={tienePermisoHistoriaClinica}
            />

            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <Row className="mb-2">
                            <Col sm={6}>
                                <h1>
                                    <i className="fas fa-syringe"></i> Toxina Botulínica
                                </h1>
                            </Col>
                            <Col sm={6}>
                                <Button 
                                    variant="secondary" 
                                    className="float-right"
                                    onClick={volverAtenderPaciente}
                                >
                                    <i className="fas fa-arrow-left"></i> Volver a Atención
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </section>

                <section className="content">
                    <div className="container-fluid">
                        
                        {/* VISTA LISTADO */}
                        {view === 'list' && (
                            <Card>
                                <Card.Header className="bg-dark text-white">
                                    <Row>
                                        <Col>
                                            <h3 className="card-title mb-0 text-white">
                                                Historial de Aplicaciones - {nombrePacienteListado || 'Paciente'}
                                            </h3>
                                        </Col>
                                        <Col className="text-right">
                                            <Button variant="success" onClick={handleNuevo}>
                                                <i className="fas fa-plus"></i> Nueva Aplicación
                                            </Button>
                                        </Col>
                                    </Row>
                                </Card.Header>
                                <Card.Body>
                                    <Table striped bordered responsive hover>
                                        <thead>
                                            <tr>
                                                <th>Fecha</th>
                                                <th>Profesional</th>
                                                <th>Unid. Frontal</th>
                                                <th>Unid. Lateral</th>
                                                <th>Total</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {registros.map((r, i) => (
                                                <tr key={i}>
                                                    <td>{r.fecha_hora}</td>
                                                    <td>{r.profesional_nombre}</td>
                                                    <td>{r.unidades_totales || 0}</td>
                                                    <td>{r.unidades_totales2 || 0}</td>
                                                    <td><strong>{(parseFloat(r.unidades_totales || 0) + parseFloat(r.unidades_totales2 || 0))}</strong></td>
                                                    <td>
                                                        <Button size="sm" variant="info" onClick={() => handleVer(r)}>
                                                            <i className="fas fa-eye"></i> Ver
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                            {registros.length === 0 && (
                                                <tr>
                                                    <td colSpan="6" className="text-center">
                                                        No hay registros de aplicaciones.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </Card.Body>
                            </Card>
                        )}

                        {/* VISTA CREAR/VER */}
                        {(view === 'create' || view === 'show') && (
                            <Row>
                                {/* Columna izquierda: Imagen */}
                                <Col lg={8}>
                                    <Card>
                                        <Card.Body>
                                            {/* Pestañas */}
                                            <div className="btn-group w-100 mb-3" role="group">
                                                <Button
                                                    variant={activeTab === 'frente' ? 'dark' : 'outline-secondary'}
                                                    onClick={() => setActiveTab('frente')}
                                                >
                                                    Vista Frontal
                                                </Button>
                                                <Button
                                                    variant={activeTab === 'lateral' ? 'success' : 'outline-secondary'}
                                                    onClick={() => setActiveTab('lateral')}
                                                >
                                                    Vista Lateral
                                                </Button>
                                            </div>

                                            {/* Imagen con puntos */}
                                            <div id="toxina-container-print" className="text-center bg-white border p-3">
                                                <div style={{ position: 'relative', display: 'inline-block', maxWidth: '100%' }}>
                                                    <img
                                                        ref={activeTab === 'frente' ? imgFrenteRef : imgLateralRef}
                                                        src={activeTab === 'frente' ? imgFrente : imgLateral}
                                                        alt={`Vista ${activeTab === 'frente' ? 'Frontal' : 'Lateral'}`}
                                                        style={{ 
                                                            maxHeight: '70vh', 
                                                            width: 'auto', 
                                                            display: 'block', 
                                                            cursor: view === 'create' ? 'crosshair' : 'default' 
                                                        }}
                                                        onClick={(e) => handleImageClick(e, activeTab)}
                                                    />
                                                    {renderPuntos(activeTab)}
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>

                                {/* Columna derecha: Controles */}
                                <Col lg={4}>
                                    <Card className="sticky-top" style={{ top: '20px' }}>
                                        <Card.Header className="bg-info">
                                            <h5 className="mb-0">
                                                <i className="fas fa-cog"></i> Controles
                                            </h5>
                                        </Card.Header>
                                        <Card.Body>
                                            {/* Fecha */}
                                            <Form.Group className="mb-3">
                                                <Form.Label>Fecha y Hora</Form.Label>
                                                <Form.Control 
                                                    type="datetime-local"
                                                    value={fechaHora}
                                                    onChange={e => setFechaHora(e.target.value)}
                                                    disabled={view === 'show'}
                                                />
                                            </Form.Group>

                                            {view === 'create' && (
                                                <>
                                                    {/* Cantidad */}
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Cantidad a Inyectar (Unidades)</Form.Label>
                                                        <Form.Control 
                                                            type="number"
                                                            value={valorDefecto}
                                                            onChange={e => setValorDefecto(e.target.value)}
                                                            placeholder="Ej: 5"
                                                        />
                                                    </Form.Group>

                                                    {/* Herramientas */}
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Herramienta</Form.Label>
                                                        <div className="btn-group w-100">
                                                            <Button 
                                                                variant={herramienta === 'toxina' ? 'primary' : 'outline-primary'}
                                                                onClick={() => setHerramienta('toxina')}
                                                            >
                                                                <i className="fas fa-syringe"></i> Inyectar
                                                            </Button>
                                                            <Button 
                                                                variant={herramienta === 'borrador' ? 'danger' : 'outline-danger'}
                                                                onClick={() => setHerramienta('borrador')}
                                                            >
                                                                <i className="fas fa-eraser"></i> Borrar
                                                            </Button>
                                                        </div>
                                                        <small className="text-muted">
                                                            <i className="fas fa-info-circle"></i> Haga clic en la imagen para marcar puntos
                                                        </small>
                                                    </Form.Group>

                                                    <hr />
                                                </>
                                            )}

                                            {/* Totales */}
                                            <div className="alert alert-info">
                                                <h6><i className="fas fa-calculator"></i> Totales de Unidades</h6>
                                                <div className="mb-2">
                                                    <strong>Frontal:</strong> {calcularTotal('frente')} U
                                                </div>
                                                <div className="mb-2">
                                                    <strong>Lateral:</strong> {calcularTotal('lateral')} U
                                                </div>
                                                <hr />
                                                <div>
                                                    <h5 className="mb-0">
                                                        <strong>Total Global:</strong> {calcularTotalGlobal()} U
                                                    </h5>
                                                </div>
                                            </div>

                                            {/* Observaciones */}
                                            <Form.Group className="mb-3">
                                                <Form.Label>Observaciones</Form.Label>
                                                <Form.Control 
                                                    as="textarea"
                                                    rows={4}
                                                    value={observaciones}
                                                    onChange={e => setObservaciones(e.target.value)}
                                                    readOnly={view === 'show'}
                                                    placeholder="Ingrese observaciones sobre la aplicación..."
                                                />
                                            </Form.Group>

                                            {/* Botones de acción */}
                                            <div className="d-grid gap-2">
                                                <Button 
                                                    variant="secondary"
                                                    onClick={() => setView('list')}
                                                >
                                                    <i className="fas fa-arrow-left"></i> Volver al Listado
                                                </Button>
                                                
                                                {view === 'create' && (
                                                    <Button 
                                                        variant="success" 
                                                        size="lg"
                                                        onClick={guardar}
                                                        disabled={loading}
                                                    >
                                                        <i className="fas fa-save"></i> Guardar Aplicación
                                                    </Button>
                                                )}
                                                
                                                {view === 'show' && (
                                                    <Button 
                                                        variant="danger"
                                                        onClick={descargarPDF}
                                                    >
                                                        <i className="fas fa-file-pdf"></i> Generar PDF
                                                    </Button>
                                                )}
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        )}

                    </div>
                </section>
            </div>

            <Footer />

            <ModalArchivosClinicos
                show={showArchivosClinicos}
                onHide={cerrarArchivosClinicos}
            />

            <Modal show={showRipsSinFev} onHide={() => setShowRipsSinFev(false)} size="xl" enforceFocus={false}>
                <Modal.Header closeButton><Modal.Title>Registro RIPS Sin FEV</Modal.Title></Modal.Header>
                <Modal.Body><RegistroRipsSinFev paciente={obtenerPacienteParaRips()} /></Modal.Body>
            </Modal>

            <Modal show={showRipsFev} onHide={() => setShowRipsFev(false)} size="xl" enforceFocus={false}>
                <Modal.Header closeButton><Modal.Title>Registro RIPS FEV</Modal.Title></Modal.Header>
                <Modal.Body><RegistroRipsFev paciente={obtenerPacienteParaRips()} onClose={() => setShowRipsFev(false)} /></Modal.Body>
            </Modal>

            <Modal show={showRipsConvenio} onHide={cerrarRipsConvenio} size="xl" enforceFocus={false}>
                <Modal.Header closeButton><Modal.Title>Registro RIPS Por Convenio</Modal.Title></Modal.Header>
                <Modal.Body>
                    <RegistroRipsConvenio cargarHistorial={cargarHistorialRipsConvenio} cerrarModal={cerrarRipsConvenio} paciente={obtenerPacienteParaRips()} />
                </Modal.Body>
            </Modal>

            <DocumentoPacienteModal show={showExamenes} onHide={cerrarExamenes} title="Ayudas Diagnósticas">
                <ModalExamenes cargarHistorial={cargarHistorialExamenes} cerrarModal={cerrarExamenes} anamnesis={getInfoAnamnesisPDF} docPaciente={paciente?.numeroDocumento || paciente?.numero_documento} paciente={paciente} />
            </DocumentoPacienteModal>

            <DocumentoPacienteModal show={showFormulas} onHide={cerrarFormulas} title="Fórmulas Médicas">
                <ModalFormulas cargarHistorial={cargarHistorialFormulas} cerrarModal={cerrarFormulas} anamnesis={getInfoAnamnesisPDF} docPaciente={paciente?.numeroDocumento || paciente?.numero_documento} paciente={paciente} />
            </DocumentoPacienteModal>

            <DocumentoPacienteModal show={showIncapacidades} onHide={cerrarIncapacidades} title="Incapacidades">
                <ModalIncapacidades cargarHistorial={cargarHistorialIncapacidades} cerrarModal={cerrarIncapacidades} anamnesis={getInfoAnamnesisPDF} docPaciente={paciente?.numeroDocumento || paciente?.numero_documento} paciente={paciente} />
            </DocumentoPacienteModal>

            <DocumentoPacienteModal show={showRecomendaciones} onHide={cerrarRecomendaciones} title="Recomendaciones">
                <ModalRecomendaciones cargarHistorial={cargarHistorialRecomendaciones} cerrarModal={cerrarRecomendaciones} anamnesis={getInfoAnamnesisPDF} docPaciente={paciente?.numeroDocumento || paciente?.numero_documento} paciente={paciente} />
            </DocumentoPacienteModal>

            <DocumentoPacienteModal show={showRemisiones} onHide={cerrarRemisiones} title="Remisiones">
                <ModalRemisiones cargarHistorial={cargarHistorialRemisiones} cerrarModal={cerrarRemisiones} anamnesis={getInfoAnamnesisPDF} docPaciente={paciente?.numeroDocumento || paciente?.numero_documento} paciente={paciente} />
            </DocumentoPacienteModal>

            <DocumentoPacienteModal show={showContraremisiones} onHide={cerrarContraremisiones} title="Contraremisiones">
                <ModalContraremisiones cargarHistorial={cargarHistorialContraremisiones} cerrarModal={cerrarContraremisiones} anamnesis={getInfoAnamnesisPDF} docPaciente={paciente?.numeroDocumento || paciente?.numero_documento} paciente={paciente} />
            </DocumentoPacienteModal>

            <DocumentoPacienteModal show={showConsentimientos} onHide={cerrarConsentimientos} title="Consentimientos">
                <ModalConsentimientos cargarHistorial={cargarHistorialConsentimientos} cerrarModal={cerrarConsentimientos} anamnesis={getInfoAnamnesisPDF} docPaciente={paciente?.numeroDocumento || paciente?.numero_documento} paciente={paciente} />
            </DocumentoPacienteModal>

            <ModalOdontograma
                show={showOdontograma}
                onHide={cerrarOdontograma}
                pacienteId={paciente_id}
                paciente={{
                    primerNombre: paciente?.primerNombre ?? paciente?.primer_nombre ?? '',
                    segundoNombre: paciente?.segundoNombre ?? paciente?.segundo_nombre ?? '',
                    primerApellido: paciente?.primerApellido ?? paciente?.primer_apellido ?? '',
                    segundoApellido: paciente?.segundoApellido ?? paciente?.segundo_apellido ?? '',
                    tipoDocumento: paciente?.tipoDocumento ?? paciente?.tipo_documento ?? '',
                    numeroDocumento: paciente?.numeroDocumento ?? paciente?.numero_documento ?? '',
                }}
            />
        </div>
    );
}

export default ToxinaBotulinica;
